var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',[_c('tab-bar-chart',{staticClass:"pb-3",attrs:{"title":_vm.title,"chartdata":_vm.barChartData,"height":_vm.height,"compose-labels":false,"options":_vm.options,"label-size":_vm.labelSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }